<template>
    <div class="hotel-filters">
        <selected-filters
            :selected="filterValues"
            :translatable="[
                'distance',
                'mealTypes',
                'availability',
                'supplierCode',
                'specialOffer',
                'wishlist',
                'cancellationPolicy',
                'supplierRating',
                'ratingByClientsFeedback',
            ]"
            @delete-filter="clearFilter"
        />
        <price-filter
            v-if="filters.price"
            :filter-values="filterValues"
            :filters="filters"
            :nights="nights"
            :currency="currency"
            @change="change($event)"
        />
        <checkbox-filter
            v-if="filters.supplierName && filters.supplierName.length > 1 && isTO1"
            :filter-values="filterValues"
            :filters="filters"
            filter="supplierName"
            @change="change($event)"
        />
        <name-filter
            :filter-values="filterValues"
            :filters="filters"
            filter="name"
            :placeholder="$t('filterHotelNamePlaceholder')"
            @change="change($event)"
        />
        <checkbox-filter
            v-if="filters.availability && filters.availability.length > 1"
            :filter-values="filterValues"
            :filters="filters"
            filter="availability"
            :translate-labels="true"
            @change="change($event)"
        />
        <checkbox-filter
            v-if="filters.cancellationPolicy && filters.cancellationPolicy.length > 1"
            :filter-values="filterValues"
            :filters="filters"
            :translate-labels="true"
            filter="cancellationPolicy"
            @change="change($event)"
        />
        <supplier-filter
            v-if="filters.supplierCode && filters.supplierCode.length && !hideSupplierCodeFilter"
            :filter-values="filterValues"
            :filters="filters"
            @change="change($event)"
        />
        <checkbox-filter
            v-if="filters.category && filters.category.length > 1"
            :filter-values="filterValues"
            :filters="filters"
            filter="category"
            :translate-labels="true"
            :pluralization="true"
            @change="change($event)"
        />
        <checkbox-filter
            v-if="filters.type && filters.type.length > 1"
            :filter-values="filterValues"
            :filters="filters"
            filter="type"
            @change="change($event)"
        />
        <checkbox-filter
            v-if="filters.mealTypes && filters.mealTypes.length > 1"
            :filter-values="filterValues"
            :filters="filters"
            :translate-labels="true"
            filter="mealTypes"
            @change="change($event)"
        />
        <checkbox-filter
            v-if="filters.wishlist && filters.wishlist.length"
            :filter-values="filterValues"
            :filters="filters"
            :translate-labels="true"
            filter="wishlist"
            @change="change($event)"
        />
        <checkbox-filter
            v-if="filters.specialOffer && filters.specialOffer.length > 1 && !$conf.public.disableSpecialOffers"
            :filter-values="filterValues"
            :filters="filters"
            :translate-labels="true"
            filter="specialOffer"
            :panel-expanded="false"
            @change="change($event)"
        />
        <checkbox-filter
            v-if="filters.location && filters.location.length > 1"
            :filter-values="filterValues"
            :filters="filters"
            :translate-labels="true"
            :panel-expanded="false"
            filter="location"
            @change="change($event)"
        />
        <checkbox-filter
            v-if="filters.district && filters.district.length > 1"
            :filter-values="filterValues"
            :filters="filters"
            filter="district"
            :panel-expanded="false"
            @change="change($event)"
        />
        <checkbox-filter
            v-if="filters.distance && filters.distance.length > 1"
            :filter-values="filterValues"
            :filters="filters"
            filter="distance"
            :translate-labels="true"
            :panel-expanded="false"
            @change="change($event)"
        />
        <checkbox-filter
            v-if="filters.chain && filters.chain.length > 0"
            :filter-values="filterValues"
            :filters="filters"
            filter="chain"
            :panel-expanded="false"
            @change="change($event)"
        />
        <checkbox-filter-grouped
            v-if="filters.services && filters.services.length > 1"
            :filter-values="filterValues"
            :filters="filters"
            filter="services"
            :panel-expanded="false"
            @change="change($event)"
        />
        <checkbox-filter
            v-if="filters.popularServices && filters.popularServices.length > 1"
            :filter-values="filterValues"
            :filters="filters"
            filter="popularServices"
            :panel-expanded="false"
            @change="change($event)"
        />
        <checkbox-filter
            v-if="filters.roomServices && filters.roomServices.length > 1"
            :filter-values="filterValues"
            :filters="filters"
            filter="roomServices"
            :panel-expanded="false"
            @change="change($event)"
        />
        <checkbox-filter
            v-if="filters.classifications && filters.classifications.length > 1"
            :filter-values="filterValues"
            :filters="filters"
            filter="classifications"
            :panel-expanded="false"
            @change="change($event)"
        />
        <checkbox-filter
            v-if="filters.shared && filters.shared.length > 1"
            :filter-values="filterValues"
            :filters="filters"
            filter="shared"
            :panel-expanded="false"
            @change="change($event)"
        />
        <checkbox-filter
            v-if="filters.roomTypes && filters.roomTypes.length > 1"
            :filter-values="filterValues"
            :filters="filters"
            filter="roomTypes"
            :panel-expanded="false"
            @change="change($event)"
        />
        <checkbox-filter
            v-if="filters.bedTypes && filters.bedTypes.length > 1"
            :filter-values="filterValues"
            :filters="filters"
            :panel-expanded="false"
            filter="bedTypes"
            translate-labels
            @change="change($event)"
        />
        <checkbox-filter
            v-if="showSupplierRating && filters.supplierRating && filters.supplierRating.length > 1"
            :filter-values="filterValues"
            :filters="filters"
            :panel-expanded="false"
            filter="supplierRating"
            translate-labels
            @change="change($event)"
        />
        <checkbox-filter
            v-if="filters.ratingByClientsFeedback && filters.ratingByClientsFeedback.length > 1"
            v-model="filterValues"
            :filters="filters"
            :panel-expanded="false"
            filter="ratingByClientsFeedback"
            translate-labels
            @change="change($event)"
        />
        <tripadvisor-filter
            v-if="filters.tripadvisorRating && filters.tripadvisorRating.length > 1"
            :filter-values="filterValues"
            :filters="filters"
            :translate-labels="true"
            filter="tripadvisorRating"
            :panel-expanded="false"
            @change="change($event)"
        />
        <filtered-mobile-button
            v-if="$breakpoint.smAndDown"
            class="sticky-button"
            :count="filteredOffersCount"
            :visible="Object.keys(filterValues).length > 0"
            @change-mode="goToOffers"
            @clear-filters="reset"
        />
    </div>
</template>

<script lang="ts">
    import {Component, Prop} from 'vue-facing-decorator'
    import CheckboxFilter from '@/components/search/filters/CheckboxFilter.vue'
    import TripadvisorFilter from '@/components/search/filters/TripadvisorFilter.vue'
    import FilteredMobileButton from '~/components/snippets/FilteredMobileButton.vue'
    import SelectedFilters from '~/components/snippets/SeletedFilters.vue'
    import PriceFilter from '~src/components/search/filters/priceFilter.src'
    import NameFilter from '~/components/filters/NameFilter.vue'
    import {FiltersBase} from '~/components/search/FiltersBase.vue'
    import SupplierFilter from '~src/components/search/filters/SupplierFilter.vue'
    import CheckboxFilterGrouped from '@/components/search/filters/CheckboxFilterGrouped.vue'

    @Component({
        components: {
            CheckboxFilterGrouped,
            SupplierFilter,
            PriceFilter,
            CheckboxFilter,
            TripadvisorFilter,
            FilteredMobileButton,
            SelectedFilters,
            NameFilter,
        },
    })
    export class HotelFilters extends FiltersBase {
        @Prop({required: true, default: 1}) nights

        get showSupplierRating() {
            return false
        }

        get hideSupplierCodeFilter() {
            return false
        }
    }

    export default HotelFilters
</script>
